exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search[data-v-3bad7ced] {\n  display: flex;\n  justify-content: flex-end;\n}\n.search .search-text[data-v-3bad7ced] {\n    border-radius: 20px;\n    padding: 8px 15px;\n    border-color: #939dad;\n}\n.search .clear-btn[data-v-3bad7ced] {\n    font-size: 1.3rem;\n    padding: 5px 0px;\n    cursor: pointer;\n    z-index: 10;\n    right: 1rem;\n    position: absolute;\n}\n.search .search-icon[data-v-3bad7ced] {\n    font-size: 1.3rem;\n    padding: 6px 10px;\n}\n.tab-header h5[data-v-3bad7ced] {\n  text-transform: uppercase;\n}\n.tab-header[data-v-3bad7ced] {\n  display: flex;\n  justify-content: space-between;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bad7ced","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/utils/SearchBar.vue
// module id = 1081
// module chunks = 2